/**
 * Submitted — the confirmation screen after a free-estimate submit.
 *
 * ProjectSummary navigates here once the project is submitted server-side
 * (status SUBMITTED). There is no payment and no checkout — this just confirms
 * and sets the expectation for turnaround.
 */
import { useNavigate } from 'react-router-dom';

export function Paid(): JSX.Element {
  const navigate = useNavigate();

  return (
    <div className="flow flow--single">
      <div className="stage-card">
        <div className="pb-note pb-note--good" role="status">
          Submitted &mdash; thank you.
        </div>
        <h1>We&rsquo;re on it.</h1>
        <p className="stage-card__lede">
          Your project is in our hands. We&rsquo;ll review your scope and get your estimate back to
          you by the end of the next business day.
        </p>
        <div className="pb-surface">
          <div className="pb-option__label">What happens next</div>
          <div className="estimate__hint" style={{ marginTop: 'var(--pb-2)' }}>
            We read through the scope you built, put your numbers together, and reach out with your
            estimate &mdash; no charge, no obligation.
          </div>
        </div>
        <div className="q-actions" style={{ flexDirection: 'column' }}>
          <button
            type="button"
            className="pb-btn pb-btn--lg"
            onClick={() => navigate('/dashboard')}
          >
            Back to my projects
          </button>
        </div>
      </div>
    </div>
  );
}
